import { render, staticRenderFns } from "./PaymentTravelPackegeSuccess.vue?vue&type=template&id=40a314b0"
var script = {}
import style0 from "./PaymentTravelPackegeSuccess.vue?vue&type=style&index=0&id=40a314b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports